module.exports = __webpack_public_path__ + "img/stickers-portfolio1.9f153c1f.png";